import app from 'flarum/forum/app';
import sortTags from './sortTags';

export default function sortCategoryByTag(_tag) {
  // Not a primary tag, so no children
  if (!_tag || (_tag.isPrimary && !_tag.isPrimary())) {
    return [];
  }

  // Get all tags
  const tags = app.store.all('tags');

  let categories = [];

  // Sort tags
  sortTags(tags)
    .filter((tag) => tag.parent() && tag.parent().id() == _tag.id())
    .forEach((foundTag) => categories.push(foundTag));

  return categories;
}
